/**
 * Constants for PowerEditor component
 */

// Shared CSS classes
const POWER_EDITOR_STYLES = {
    activeButton: "bg-purple-600 hover:bg-purple-700 text-white shadow-sm",
    divider: "h-6 w-px bg-border mx-2",
    buttonBase: "h-8 w-8 p-0",
    toolbarGroup: "flex items-center gap-0.5 bg-muted rounded-md p-0.5",
} as const;

// Template port mappings
const TEMPLATE_PORT_MAP: Record<string, { service: string; port: number }> = {
    "5173": { service: "vite", port: 5173 },
    "3000": { service: "next", port: 3000 },
    "3001": { service: "api", port: 3001 },
    "8000": { service: "uni", port: 8000 },
};

// Default app service
const DEFAULT_APP_SERVICE = { service: "vite", port: 5173 };

// Viewport device presets
const VIEWPORT_DEVICES = [
    {
        key: "mobile",
        label: "Mobile",
        dimensions: "390×844",
    },
    {
        key: "tablet",
        label: "Tablet",
        dimensions: "768×1024",
    },
    {
        key: "desktop",
        label: "Desktop",
        dimensions: "1440×900",
    },
    {
        key: "signagePortrait",
        label: "Signage Portrait",
        dimensions: "1080×1920",
    },
    {
        key: "signageLandscape",
        label: "Signage Landscape",
        dimensions: "1920×1080",
    },
] as const;

// Default custom viewport dimensions
const DEFAULT_CUSTOM_VIEWPORT = {
    width: 1440,
    height: 900,
} as const;

export {
    POWER_EDITOR_STYLES,
    TEMPLATE_PORT_MAP,
    DEFAULT_APP_SERVICE,
    VIEWPORT_DEVICES,
    DEFAULT_CUSTOM_VIEWPORT,
};
